import uuidv4 from "uuid/v4";
import Vue from "vue";
import {
	ERequestType,
	fetchGetHelper,
	fetchPostHelper,
} from "../../tools/fetch";

// GIT NOTE : git version d7f81b91 -> before remove subservices

/*************************************
 State
 **/
const state = {
	allDiscount: {},
	selectedDiscount: null,
	isLoaded: false,
};

/*************************************
 Getters
 **/
const getters = {
	/**
	 * get all discounts of current resto
	 * @param {*} state
	 */
	getAllDiscount: function (state) {
		return state.allDiscount;
	},

	/**
	 * get selected Discount
	 */
	getSelectedDiscount: function (state) {
		// TODO: get correct data
		return state.selectedDiscount;
	},

	/**
	 * Get number of interval in service
	 * @param {*} msSelect main service selected
	 * @param {*} dSelect day selected
	 */

	/**
	 * get Service Form Init return service object formated with default values
	 */
	getServiceFormInit: function (state, getters) {
		let formatedData = {};
		formatedData["daysSortedById"] = [];
		// for each mainServices
		Object.entries(getters["getAllServices"]);

		return formatedData;
	},

	/**
	 * get Service datas is loaded
	 */
	getDiscountIsLoaded: function (state) {
		return state.isLoaded;
	},
};

/*************************************
 Mutations
 **/
const mutations = {
	/**
	 * set all services datas
	 * @param {*} state
	 * @param {*} dbData
	 */
	setAllDiscount(state, dbData) {
		state.allDiscount = dbData;
	},

	/**
	 * set selected services for day
	 * @param {*} state
	 * @param {*} arry
	 */
	setSelectedDiscount(state, dbData) {
		state.selectedDiscount = dbData;
	},

	/**
	 * set selected services for day
	 * @param {*} state
	 * @param {*} arry
	 */
	clearSelectedDiscount(state) {
		Vue.set(state, "selectedDiscount", null);
	},

	/**
	 * set selected services for day
	 * @param {*} state
	 * @param {*} arry
	 */
	setSelectedDiscountById(state, searchId) {
		state.selectedDiscount = state.allDiscount.find((el) => el.id === searchId);
	},

	/**
	 * set loaded store state
	 * @param {*} state
	 * @param {*} val
	 */
	setLoadedState(state, val) {
		state.isLoaded = val;
	},

	/**
	 * reset store
	 * @param {*} state
	 */
	resetStore(state) {
		state.allDiscount = {};
		state.selectedDiscount = {};
		state.isLoaded = false;
	},
};

/*************************************
 Action
 **/
const actions = {
	/**
	 * Clean store
	 * @param {*} store params
	 */
	cleanStore: function ({ state, rootState, commit, dispatch }) {
		commit("resetStore");
	},

	/**
	 * Create Main service
	 * @param {*} param0
	 * @param {*} payload:Object {
	 *  name
	 *  order
	 * }
	 */
	createDiscount: function (
		{ state, rootState, commit, dispatch, getters, rootGetters },
		payload,
	) {
		// TODO: check if Discount all ready exist on same day date and hours
		let found = false;
		let userDatas = rootGetters["newUsers/getUser"];
		let uid = rootGetters["newUsers/getUidPublic"];

		return new Promise((resolve, reject) => {
			// if already reject
			if (found) {
				reject(new Error("Le service exist déjà"));
			} else {
				// else create service
				let newId =
					`${payload.name.toLowerCase().replace(/[^A-Z0-9]+/gi, "_")}_${uuidv4()}`;
				if (state.selectedDiscount) newId = state.selectedDiscount.id;

				let newDiscount = {
					id: newId,
					restoid: uid,
					name: payload.name,
					desc: payload.desc,
					dates: payload.dates,
					Lundi: payload.Lundi,
					Mardi: payload.Mardi,
					Mercredi: payload.Mercredi,
					Jeudi: payload.Jeudi,
					Vendredi: payload.Vendredi,
					Samedi: payload.Samedi,
					Dimanche: payload.Dimanche,
				};

				// send datas to db
				fetchPostHelper(
					ERequestType.DISCOUNT.CREATE,
					newDiscount,
					userDatas.token,
				)
					.then((res) => {
						dispatch("loadDiscountStore");
						dispatch("newServices/loadServicesStore", false, { root: true });
						resolve(res.data);
					})
					.catch((err) => {
						console.error(err);
						reject(err);
					});
			}
		});
	},

	/**
	 * remove main services
	 * @param {*} payload:Object {
	 *  - name: string,
	 *  - id: string
	 * }
	 */
	async deleteDiscountById(
		{ state, rootState, commit, dispatch, getters, rootGetters },
		payload,
	) {
		let userDatas = rootGetters["newUsers/getUser"];

		let discountToDelete = state.allDiscount.find((el) => el.id === payload);
		// delete on db
		return new Promise(async (resolve, reject) => {
			await fetchPostHelper(
				ERequestType.DISCOUNT.DELETE,
				discountToDelete,
				userDatas.token,
			)
				.then(async (res) => {
					dispatch("loadDiscountStore");
					dispatch("newServices/loadServicesStore", false, { root: true });
					resolve();
				})
				.catch((err) => {
					console.error(err);
					reject(err);
				});
		});
	},

	/**
	 * load all service for selected restoid
	 * @param {*} param0
	 */
	loadDiscountStore: function ({
		state,
		rootState,
		commit,
		dispatch,
		getters,
		rootGetters,
	}) {
		// get all datas for db
		let uid = rootGetters["newUsers/getUidPublic"];
		return new Promise((resolve, reject) => {
			fetchGetHelper(ERequestType.DISCOUNT.ALL, `restoid=${uid}`)
				.then((res) => {
					// if no services found
					if (res.data.length === 0) {
						commit("setAllDiscount", {});
						commit("setSelectedDiscount", {});
						commit("setLoadedState", true);
						resolve();
						return;
					}
					commit("setAllDiscount", res.data);

					commit("setLoadedState", true);
					resolve();
				})
				.catch((err) => {
					// set loaded state
					commit("setLoadedState", true);
					reject(err);
				});
		});
	},

	/**
	 * load all service for selected restoid
	 * @param {*} param0
	 */
	loadDiscountStoreVisible: function ({
		state,
		rootState,
		commit,
		dispatch,
		getters,
		rootGetters,
	}) {
		// get all datas for db
		let uid = rootGetters["newUsers/getUidPublic"];
		return new Promise((resolve, reject) => {
			fetchGetHelper(ERequestType.DISCOUNT.VISIBLE, `restoid=${uid}`)
				.then((res) => {
					// if no services found
					if (res.data.length === 0) {
						commit("setAllDiscount", {});
						commit("setSelectedDiscount", {});
						commit("setLoadedState", true);
						resolve();
						return;
					}
					commit("setAllDiscount", res.data);

					commit("setLoadedState", true);
					resolve();
				})
				.catch((err) => {
					// set loaded state
					commit("setLoadedState", true);
					reject(err);
				});
		});
	},
};

/*************************************
 Helpers
 **/

/*************************************
 Export module
 **/
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
